// PWA Install Prompt
// Shows mobile users how to add 90mod to their home screen
// Respects 30-day dismissal cooldown

(function() {
  'use strict';

  const STORAGE_KEY = 'mod_pwa_dismissed';
  const COOLDOWN_DAYS = 30;
  
  // Check if we should show the prompt
  function shouldShowPrompt() {
    // Only show on mobile
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (!isMobile) return false;
    
    // Check if already installed (standalone mode)
    if (window.matchMedia('(display-mode: standalone)').matches) return false;
    if (window.navigator.standalone === true) return false; // iOS
    
    // Check dismissal cooldown
    const dismissed = localStorage.getItem(STORAGE_KEY);
    if (dismissed) {
      const dismissedTime = new Date(dismissed);
      const now = new Date();
      const daysSince = (now - dismissedTime) / (1000 * 60 * 60 * 24);
      if (daysSince < COOLDOWN_DAYS) return false;
    }
    
    return true;
  }
  
  // Dismiss the prompt
  function dismissPrompt() {
    localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    hidePrompt();
  }
  
  // Show the prompt
  function showPrompt() {
    const prompt = document.getElementById('pwa-install-prompt');
    if (prompt) {
      prompt.classList.remove('hidden');
      setTimeout(() => {
        prompt.classList.add('pwa-prompt--visible');
      }, 100);
    }
  }
  
  // Hide the prompt
  function hidePrompt() {
    const prompt = document.getElementById('pwa-install-prompt');
    if (prompt) {
      prompt.classList.remove('pwa-prompt--visible');
      setTimeout(() => {
        prompt.classList.add('hidden');
      }, 300);
    }
  }
  
  // Get platform-specific instructions
  function getInstructions() {
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const isSafari = /Safari/i.test(navigator.userAgent) && !/Chrome|CriOS|FxiOS/i.test(navigator.userAgent);
    
    if (isIOS && isSafari) {
      return {
        icon: `<svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M16 5l-1.42 1.42-1.59-1.59V16h-1.98V4.83L9.42 6.42 8 5l4-4 4 4zm4 5v11c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V10c0-1.1.9-2 2-2h3v2H6v11h12V10h-3V8h3c1.1 0 2 .9 2 2z"/></svg>`,
        title: 'Add to Home Screen',
        steps: [
          'Tap the Share button',
          'Scroll down and tap "Add to Home Screen"',
          'Tap "Add" in the top right'
        ]
      };
    } else {
      return {
        icon: `<svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" /></svg>`,
        title: 'Install 90mod',
        steps: [
          'Tap the menu (⋮) in your browser',
          'Tap "Add to Home screen" or "Install app"',
          'Tap "Add" or "Install"'
        ]
      };
    }
  }
  
  // Build the prompt HTML
  function buildPromptHTML() {
    const instructions = getInstructions();
    
    return `
      <div id="pwa-install-prompt" class="pwa-prompt hidden">
        <div class="pwa-prompt__overlay" onclick="window.pwaDismiss()"></div>
        <div class="pwa-prompt__card">
          <div class="pwa-prompt__header">
            <div class="pwa-prompt__icon">
              ${instructions.icon}
            </div>
            <button onclick="window.pwaDismiss()" class="pwa-prompt__close" aria-label="Close">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          <div class="pwa-prompt__body">
            <h3 class="pwa-prompt__title">${instructions.title}</h3>
            <p class="pwa-prompt__subtitle">Get the best experience with the 90mod app</p>
            
            <ol class="pwa-prompt__steps">
              ${instructions.steps.map((step, i) => `
                <li class="pwa-prompt__step">
                  <span class="pwa-prompt__step-number">${i + 1}</span>
                  <span class="pwa-prompt__step-text">${step}</span>
                </li>
              `).join('')}
            </ol>
          </div>
          
          <div class="pwa-prompt__footer">
            <button onclick="window.pwaDismiss()" class="pwa-prompt__button pwa-prompt__button--secondary">
              Maybe Later
            </button>
            <button onclick="window.pwaDismiss()" class="pwa-prompt__button pwa-prompt__button--primary">
              Got It
            </button>
          </div>
        </div>
      </div>
    `;
  }
  
  // Initialize
  function init() {
    if (!shouldShowPrompt()) return;
    
    // Inject HTML
    const container = document.createElement('div');
    container.innerHTML = buildPromptHTML();
    document.body.appendChild(container.firstElementChild);
    
    // Expose dismiss function globally
    window.pwaDismiss = dismissPrompt;
    
    // Show after a short delay
    setTimeout(showPrompt, 2000);
  }
  
  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
